import _JSXStyle from "styled-jsx/style";
import { layers } from '@dhis2/ui-constants';
import { Portal } from '@dhis2-ui/portal';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
export const AlertStack = _ref => {
  let {
    className,
    children,
    dataTest = 'dhis2-uicore-alertstack'
  } = _ref;
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["1009591311", [layers.alert]]]) + " " + (cx(className) || "")
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1009591311",
    dynamic: [layers.alert]
  }, [`div.__jsx-style-dynamic-selector{position:fixed;top:auto;inset-inline-end:auto;bottom:0;inset-inline-start:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);z-index:${layers.alert};display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;pointer-events:none;}`, "div.__jsx-style-dynamic-selector:dir(rtl){-webkit-transform:translateX(50%);-ms-transform:translateX(50%);transform:translateX(50%);}"])));
};
AlertStack.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dataTest: PropTypes.string
};